import { render, staticRenderFns } from "./ProjectDifferentials.vue?vue&type=template&id=37ff0541&scoped=true&"
import script from "./ProjectDifferentials.vue?vue&type=script&lang=js&"
export * from "./ProjectDifferentials.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDifferentials.vue?vue&type=style&index=0&id=37ff0541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff0541",
  null
  
)

export default component.exports